import React from 'react'
import Button from 'material-ui/Button'
import Menu, { MenuItem } from 'material-ui/Menu'

const LanguageSelector = (props) => (
  <div>
    <Button dense raised
      aria-owns={props.anchorEl ? 'language-selector' : null}
      aria-haspopup="true"
      onClick={props.handleLanguageChange}
    >
      {props.activeLanguage.split('-')[1]}
    </Button>
    <Menu
      id="language-selector"
      anchorEl={props.anchorEl}
      anchorEl={props.anchorEl}
      open={Boolean(props.anchorEl)}
      onClose={props.handleLanguageChangeClose}
    >
      {
        props.languages.map((language, index) => {
          return (
            <MenuItem
              key={index}
              onClick={() => props.handleLanguageChangeClose(language.code)}
            >
              {language.code}
            </MenuItem>
          )
        })
      }
    </Menu>
  </div>
)

export default LanguageSelector



// WEBPACK FOOTER //
// ./src/components/i18/languageSelector.js